<template>
  <el-dialog
    class="dialog-inner"
    :model-value="visible"
    :before-close="() => {
      emit('close');
    }"
    width="500"
  >
    <template #header>
      <div class="my-header">
        <h4 class="px-2 text-xl text-[#344767] font-semibold">
          账号充值
        </h4>
      </div>
    </template>

    <div class="flex justify-center items-center mb-5">
      <img :src="BindTipCover" alt="alipay-charge" class="w-full">
    </div>

    <div class="step-form">
      <div class="flex items-center mb-3">
        <span class="text-[#909399] mr-4">企业名称</span>
        <span>{{ props.data.bizName }}</span>
      </div>

      <div class="flex items-center mb-3">
        <span class="text-[#909399] mr-4">资金通道</span>
        <span>商户支付宝</span>
      </div>

      <div class="flex items-center">
        <span class="text-[#909399] mr-4">当前余额</span>
        <span>{{ props.data.availableBalance }}元</span>
      </div>

      <!-- 说明 -->
      <div class="flex flex-col bg-[#E8F2FF] text-[#3194FA] text-[12px] my-5 px-3 py-2 border border-[#D1E4FF] rounded-sm">
        <div class="text-[#595959]">
          <span>商户先将资金</span>
          <a
            href="https://cshall.alipay.com/enterprise/knowledgeDetail.htm?knowledgeId=201602796520"
            target="_blank"
            class="text-[#3194FA] underline"
          >
            转入本企业支付宝
          </a>
          <span>然后在下方填入充值金额，并点击跳转完成充值</span>
        </div>
      </div>

      <div class="flex items-center mb-3">
        <span class="text-[#909399] mr-4">商户支付宝</span>
        <span>{{ props.data.bizName }}</span>
      </div>

      <el-form
        ref="formRef"
        require-asterisk-position="right"
        label-position="top"
        :model="formValues"
        :rules="formRules"
      >
        <el-form-item prop="amount" label="充值金额">
          <el-input
            id="amount-input"
            v-model="formValues.amount"
            size="large"
            autocomplete="new-password"
            placeholder="请输入充值金额"
            @keydown="(e: KeyboardEvent | Event) => {
              if ((e as KeyboardEvent).keyCode === 13) {
                e.preventDefault();
                onConfirm();
              }
            }"
          >
            <template #suffix>
              元
            </template>
          </el-input>
        </el-form-item>
      </el-form>
    </div>

    <template #footer>
      <div class="flex justify-end">
        <el-button @click="emit('close')">
          取消
        </el-button>
        <el-button type="primary" :loading="loading" @click="onConfirm">
          跳转到支付宝充值
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import BindTipCover from './bind-alipay-tips.png';
import { checkNumber, checkSmsCode } from '@core/tools';
import { FormInstance, FormRules } from 'element-plus';
import { nextTick, PropType, ref, watch } from 'vue';
import { IFinanceWallet } from '@core/main/types';

const emit = defineEmits(['close', 'confirm']);

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Object as PropType<IFinanceWallet>,
    default: () => ({}),
  },
  loading: {
    type: Boolean,
    default: false,
  },
  term: {
    type: String as PropType<'server' | 'company' | 'agent' | 'saas'>,
    default: 'server',
  },
  payPhone: {
    type: String,
    default: '',
  },
});

const formRef = ref<FormInstance>();
const formValues = ref({
  amount: '',
  code: '',
});

const formRules = ref<FormRules<any>>({
  amount: [
    {
      required: true,
      message: '请输入充值金额',
    },
    {
      validator: (rule: any, value: string, callback: any) => {
        if (checkNumber(String(formValues.value.amount), '充值金额', 2)) {
          callback(checkNumber(String(formValues.value.amount), '充值金额', 2));
        }
        callback();
      },
    },
    {
      validator: (rule: any, value: string, callback: any) => {
        if (!formValues.value.amount || Number(formValues.value.amount) <= 0) {
          callback(new Error('充值金额不能为0'));
        }
        callback();
      },
    },
  ],
  code: [
    {
      required: true,
      message: '请输入验证码',
    },
    {
      validator: (rule: any, value: string, callback: any) => {
        if (checkSmsCode(formValues.value.code)) {
          callback(checkSmsCode(formValues.value.code));
        }
        callback();
      },
    },
  ],
});

function onConfirm() {
  formRef.value?.validate(async (valid) => {
    if (valid) {
      emit('confirm', Number(formValues.value.amount));
    }
  });
}

function resetForm() {
  for (const key in formValues.value) {
    formValues.value[key] = undefined;
  }
}

watch(
  () => props.visible,
  (val) => {
    if (val) {
      nextTick(() => {
        formRef.value?.resetFields();

        setTimeout(() => {
          const input = document.querySelector('#amount-input') as HTMLInputElement;

          if (input) {
            input.focus();
          }
        }, 600);
      });
    } else {
      resetForm();
    }
  },
);
</script>

<style lang="scss" scoped>
:deep(.dialog-inner .el-dialog__body) {
  overflow-y: unset !important;
}

.step-node {
  @apply flex items-center justify-center;

  &.active {
    @apply text-[#1777FF];
  }

  span {
    @apply ml-1;
  }
}
</style>
